// Chatbot.tsx

import { useCallback, useEffect, useState } from 'react';
import './styles.scss';
// Adjust the path accordingly
import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import ChatbotFooter from './Footer/ChatbotFooter';
import ChatbotHeader from './Header/ChatbotHeader';
import ChatbotContent from './Content/ChatbotContent';
import useChatSocket from './hooks/useChatSocket';
import ChorkiBotGif from '../../assets/chorki_animation.gif';
import { useGetChatHistoryQuery } from './store/chatbotSlice';
import { commonState, setChatbotModalOpen } from '../../app/base/commonSlice';

function Chatbot() {
  // const [modalOpen, setModalOpen] = useState(false);
  const [conversation, setConversation] = useState<any>([]);
  const { t } = useTranslation();

  // const [socketResponse, setSocketResponse] = useState(null);

  const { emitRequest, readyState, socketResponse } = useChatSocket();

  const [offset, setOffset] = useState(1);

  const [hasMore, setHasMore] = useState(true);

  const { chatbotModalOpen, language } = useSelector(commonState);

  const { data: chatHistory } = useGetChatHistoryQuery((offset - 1) * 10, {
    skip: !chatbotModalOpen,
  });

  const dispatch = useDispatch();

  const handleChatBotClick = () => {
    dispatch(setChatbotModalOpen(true));

    if (
      !isEmpty(conversation) &&
      !isEmpty(conversation[0]?.message) &&
      conversation[0]?.message[0]?.answer_type !== 'BUTTON'
    ) {
      emitRequest({ question_id: 1 });
    }
  };

  const handleCancel = () => {
    dispatch(setChatbotModalOpen(false));
  };

  // const handleStartChat = (data: boolean) => {
  //   // console.log(data);
  //   // refetch();
  //   setChatPage(data);
  // };

  const handleQuesId = (id: any) => {
    if (isEmpty(conversation)) {
      emitRequest({ question_id: id });
    }
  };

  useEffect(() => {
    const previousMessageConversation = chatHistory
      ? chatHistory?.results?.map((item: any) => ({
          sender: item?.sender,
          message: item?.msg_contents_text
            ? item?.msg_contents_text
            : item?.msg_contents_json,
        }))
      : [];

    setConversation([...conversation, ...previousMessageConversation]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatHistory]);

  useEffect(() => {
    if (socketResponse) {
      // Create a new BOT message object
      const parsedData = JSON.parse(socketResponse);

      if (parsedData && parsedData.text) {
        const messageConversation = parsedData.text
          .map((item: any) => ({
            sender: item?.sender,
            message: item?.msg_contents_text
              ? item?.msg_contents_text
              : item?.msg_contents_json,
          }))
          .sort((a: any, b: any) =>
            a?.sender?.toLowerCase().localeCompare(b?.sender?.toLowerCase())
          );

        setConversation([...messageConversation, ...conversation]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socketResponse]);

  // eslint-disable-next-line consistent-return
  const fetchMoreData = useCallback(() => {
    if (conversation?.length >= chatHistory?.count) {
      // All messages are loaded
      setHasMore(false);
      return false;
    }
    setOffset(offset + 1);
  }, [chatHistory?.count, conversation?.length, offset]);

  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <div>
      {readyState && !isMobile ? (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div
          className={`cursor-pointer ${chatbotModalOpen ? 'hidden' : 'block'}`}
          onClick={handleChatBotClick}
        >
          <div className="pr-2 text-[12px] w-[120px] h-[80px] fixed z-10 bottom-[100px] right-[10px] border-2 bg-white text-black text-right rounded-lg leading-0">
            <img
              className="absolute z-[1000] bottom-[2px] right-[68px]"
              src={ChorkiBotGif}
              alt="ChorkiBot"
            />
            <div className="pt-2 pr-2 w-[80px] float-right leading-7">
              {language === 'en' ? 'Hi! I’m ' : 'হ্যালো! আমি '}
              <span className="font-extrabold">
                {language === 'en' ? 'ChorkiBot!' : 'চর্কিবট!'}
              </span>{' '}
              {language === 'en' ? 'Need some help?' : 'কোন সাহায্য করতে পারি?'}
            </div>
          </div>
        </div>
      ) : (
        ''
      )}

      {chatbotModalOpen && !isMobile && (
        <div className="custom-modal w-[40vw] xl:w-[38vw] 2xl:w-[32vw] border-[#e5e7eb] border-2 dark:border-black shadow-lg rounded-xl bg-white dark:bg-[#323232]">
          <Tooltip title={`${t('chatbot.close')}`}>
            <button
              onClick={handleCancel}
              type="button"
              aria-label="Close"
              className="modal-close-button absolute bg-[#982723]"
            >
              <span className="ant-modal-close-x">
                <span
                  role="img"
                  aria-label="close"
                  className="anticon anticon-close ant-modal-close-icon"
                >
                  <svg
                    viewBox="64 64 896 896"
                    focusable="false"
                    data-icon="close"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" />
                  </svg>
                </span>
              </span>
            </button>
          </Tooltip>
          <div>
            <ChatbotHeader />

            <ChatbotContent
              data={conversation}
              handleQuesId={(id: any) => {
                emitRequest({ question_id: id, question_lang: language });
              }}
              hasMore={hasMore}
              fetchMoreData={fetchMoreData}
            />
          </div>
          <ChatbotFooter
            // data={socketResponse}
            // chatPage={chatPage}
            // handleStartChat={handleStartChat}
            handleQuesId={handleQuesId}
            conversation={conversation}
            // handleSocketResponse={}
          />
          {/* </Modal> */}
        </div>
      )}
    </div>
  );
}

export default Chatbot;
